import React from 'react';
import { ClipboardList } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

export default function DashboardSubmenu() {
  return (
    <>
      <div>
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Project Details and Incentive Scheme</h2>
        <p className="text-gray-600 dark:text-gray-200">Manage project details and incentive schemes</p>
      </div>

      <Card className="glass border-0 shadow-lg">
        <CardContent className="py-12">
          <div className="text-center">
            <ClipboardList className="mx-auto mb-4 h-16 w-16 text-gray-400" />
            <h3 className="mb-2 text-lg font-medium text-gray-900 dark:text-white">Project Details Module</h3>
            <p className="text-gray-500 dark:text-gray-300">This module is under development.</p>
          </div>
        </CardContent>
      </Card>
    </>
  );
}
